module.exports = __webpack_public_path__ + "static/media/doTERRA-build-guide.64cc2efb.png";